import type { Product } from '../../../models/Product';
import IconButton from '../../button/IconButton';
import ProductCard from '../card/ProductCard';
import Checkbox from '../../input/Checkbox';
import './ProductPackSelectorItem.less';

export type ProductPackSelectorItemProps = {
    animationDelay?: number;
    showPagination?: boolean;
    footerContent?: React.ReactNode;
    product: Product;
    hasMore?: boolean;
    isSelectable?: boolean;
    isSelected?: boolean;
    onNext?: () => void;
    onPrev?: () => void;
    onChangeSelection?: () => void;
    source: 'brilliant' | 'web';
};

const ProductPackSelectorItem = ({
    animationDelay = 0,
    showPagination = false,
    footerContent,
    product,
    hasMore = false,
    isSelectable = false,
    isSelected = false,
    onNext,
    onPrev,
    onChangeSelection,
    source
}: ProductPackSelectorItemProps) => {
    return (
        <div
            className={`bri-ProductPackSelectorItem ${
                showPagination ? 'bri-with-pagination' : ''
            }`}
        >
            <div className="bri-ProductPackSelectorItem-product">
                <ProductCard
                    product={product}
                    animationDelay={animationDelay}
                    hideActions
                    hideAddToCart
                    source={source}
                    featureType="product-pack"
                />
                {isSelectable && (
                    <Checkbox
                        size="large"
                        className="bri-ProductPackSelectorItem-checkbox"
                        checked={isSelected}
                        onChange={() =>
                            onChangeSelection && onChangeSelection()
                        }
                    />
                )}
            </div>
            {footerContent && (
                <div className={`bri-ProductPackSelectorItem-footer`}>
                    {showPagination && (
                        <IconButton
                            variant="default"
                            iconId="chevron-up"
                            onClick={() => onPrev && onPrev()}
                            disabled={!hasMore}
                            className="bri-ProductPackSelectorItem-pagination-button"
                        />
                    )}
                    <div className="bri-ProductPackSelectorItem-footer-content bri-DisplayFont">
                        {footerContent}
                    </div>
                    {showPagination && (
                        <IconButton
                            variant="default"
                            iconId="chevron-down"
                            onClick={() => onNext && onNext()}
                            disabled={!hasMore}
                            className="bri-ProductPackSelectorItem-pagination-button"
                        />
                    )}
                </div>
            )}
        </div>
    );
};

export default ProductPackSelectorItem;
